import amplitude from "amplitude-js";
import amplitudeMock, { shouldUseMock } from "~/services/amplitude/mock";
import config from "~/config";

const getSiteVersion = (host) => {
  switch (host) {
    case "app.onlinezdrav.ru":
      return "Прод";
    case "app.onlinezdrav-test.eltc.ru":
      return "Тест";
    default:
      return "";
  }
};

const createInstance = () => {
  const amplitudeInstance = shouldUseMock()
    ? amplitudeMock
    : amplitude.getInstance();

  amplitudeInstance.init(config.amplitudeApiKey, null, {
    includeReferrer: true,
    includeUtm: true,
  });

  amplitudeInstance.onInit(() => {
    amplitudeInstance.setUserProperties({
      "Версия сайта": getSiteVersion(window.location.host),
    });
  });

  return amplitudeInstance;
};

export default createInstance();
